/**
 * Trade apply — keep custom UI, submit to HubSpot Forms API.
 * On success, redirect to the trade thank-you page.
 */
(function () {
  function redirectToThankYou(root) {
    var url = root.getAttribute('data-thank-you') || '/pages/thank-you-page-trade';
    window.location.assign(url);
  }

  function showSuccess(root) {
    var fields = root.querySelector('[data-trade-apply-fields]');
    var success = root.querySelector('[data-trade-apply-success]');
    var errors = root.querySelector('[data-trade-apply-errors]');
    var anchorId = root.getAttribute('data-anchor') || 'apply';

    root.classList.add('is-success');

    if (fields) {
      fields.hidden = true;
      fields.setAttribute('hidden', '');
    }
    if (errors) {
      errors.hidden = true;
      errors.innerHTML = '';
    }
    if (success) {
      success.removeAttribute('hidden');
      success.hidden = false;
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try {
        success.focus({ preventScroll: true });
      } catch (e) {}
    }
    if (anchorId && window.history && window.history.replaceState) {
      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search + '#' + anchorId
      );
    }
  }

  function showError(root, message) {
    var errors = root.querySelector('[data-trade-apply-errors]');
    if (!errors) {
      window.alert(message || 'Something went wrong. Please try again.');
      return;
    }
    errors.hidden = false;
    errors.removeAttribute('hidden');
    errors.textContent = message || 'Something went wrong. Please try again.';
    errors.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function splitName(fullName) {
    var parts = String(fullName || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) {
      return { firstname: '', lastname: '' };
    }
    if (parts.length === 1) {
      return { firstname: parts[0], lastname: '-' };
    }
    return {
      firstname: parts[0],
      lastname: parts.slice(1).join(' ')
    };
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : undefined;
  }

  function getClientIp() {
    return fetch('https://api.ipify.org?format=json', { method: 'GET' })
      .then(function (response) {
        if (!response.ok) return '';
        return response.json();
      })
      .then(function (body) {
        return (body && body.ip) || '';
      })
      .catch(function () {
        return '';
      });
  }

  function buildHubSpotPayload(form, ipAddress) {
    var data = new FormData(form);
    var fullName = (data.get('full_name') || '').toString().trim();
    var names = splitName(fullName);
    var website = (data.get('website') || '').toString().trim();
    var vat = (data.get('vat') || '').toString().trim();
    var message = (data.get('message') || '').toString().trim();
    var studio = (data.get('0-2/name') || '').toString().trim();
    var address = (data.get('0-2/address') || '').toString().trim();
    var role = (data.get('primary_job_role') || '').toString().trim();
    var email = (data.get('email') || '').toString().trim();
    var phone = (data.get('phone') || '').toString().trim();
    var hear = (data.get('how_did_you_hear_about_us_') || 'Website').toString().trim();

    var notes = [];
    var cardFile = getBusinessCardFile(form);
    if (message) notes.push(message);
    if (vat) notes.push('VAT / resale: ' + vat);
    if (website) notes.push('Website: ' + website);
    if (cardFile) notes.push('Business card: ' + cardFile.name);

    var fields = [
      { name: 'firstname', value: names.firstname },
      { name: 'lastname', value: names.lastname },
      { name: 'email', value: email },
      { name: 'phone', value: phone },
      { name: '0-2/name', value: studio },
      { name: '0-2/address', value: address },
      { name: 'primary_job_role', value: role },
      { name: 'how_did_you_hear_about_us_', value: hear || 'Website' }
    ];

    if (website) {
      fields.push({ name: 'website', value: website });
    }
    if (notes.length) {
      fields.push({ name: 'message', value: notes.join('\n') });
    }

    var hutk = getCookie('hubspotutk');
    var context = {
      pageUri: window.location.href,
      pageName: document.title || 'Trade'
    };
    if (hutk) context.hutk = hutk;
    if (ipAddress) context.ipAddress = ipAddress;

    return { fields: fields, context: context };
  }

  function postHubSpot(root, form) {
    var portalId = root.getAttribute('data-hs-portal');
    var formId = root.getAttribute('data-hs-form');
    if (!portalId || !formId) {
      console.error('[Trade apply] HubSpot form is not configured', {
        portalId: portalId,
        formId: formId
      });
      return Promise.reject(new Error('HubSpot form is not configured.'));
    }

    var endpoint =
      'https://forms.hubspot.com/uploads/form/v2/' +
      encodeURIComponent(portalId) +
      '/' +
      encodeURIComponent(formId);

    return getClientIp().then(function (ipAddress) {
      var payload = buildHubSpotPayload(form, ipAddress);
      var body = new FormData();
      payload.fields.forEach(function (field) {
        body.append(field.name, field.value == null ? '' : String(field.value));
      });
      var cardFile = getBusinessCardFile(form);
      if (cardFile) {
        body.append('0-2/trade_business_card', cardFile, cardFile.name);
      }
      body.append(
        'hs_context',
        JSON.stringify(
          Object.assign({}, payload.context, {
            pageUrl: payload.context.pageUri
          })
        )
      );
      console.log('[Trade apply] Submitting to HubSpot…', {
        endpoint: endpoint,
        portalId: portalId,
        formId: formId,
        fields: payload.fields,
        businessCard: cardFile
          ? { name: cardFile.name, type: cardFile.type, size: cardFile.size }
          : null
      });

      return fetch(endpoint, {
        method: 'POST',
        body: body,
        redirect: 'manual'
      });
    }).then(function (response) {
      var accepted =
        response.type === 'opaqueredirect' ||
        response.status === 204 ||
        response.status === 302 ||
        (response.status >= 200 && response.status < 300);
      if (accepted) {
        console.log('[Trade apply] Submit OK — contact should appear in HubSpot', {
          status: response.status,
          type: response.type
        });
        return {};
      }
      return response.json().catch(function () {
        return response.text().then(function (text) {
          return { message: text };
        }).catch(function () {
          return {};
        });
      }).then(function (body) {
        var detail =
          (body && body.errors && body.errors[0] && body.errors[0].message) ||
          (body && body.localizedVisitorErrorMessage) ||
          (body && body.message) ||
          (body && body.formSubmissionError) ||
          'Something went wrong. Please try again.';
        console.error('[Trade apply] HubSpot submit failed', detail, body);
        throw new Error(detail);
      });
    });
  }

  var CARD_MAX_BYTES = 10 * 1024 * 1024;
  var CARD_EXTENSIONS = { pdf: true, jpg: true, jpeg: true, png: true, webp: true };
  var CARD_TYPES = {
    'application/pdf': true,
    'image/jpeg': true,
    'image/jpg': true,
    'image/png': true,
    'image/webp': true
  };

  function getBusinessCardFile(form) {
    var input = form.querySelector('[data-trade-apply-card]');
    if (!input || !input.files || !input.files.length) return null;
    return input.files[0];
  }

  function cardExtension(file) {
    var parts = String((file && file.name) || '').toLowerCase().split('.');
    return parts.length > 1 ? parts.pop() : '';
  }

  function validateBusinessCard(form) {
    var input = form.querySelector('[data-trade-apply-card]');
    if (!input) return true;
    var file = getBusinessCardFile(form);
    var message = '';
    if (!file) return true;
    if (!CARD_TYPES[file.type] && !CARD_EXTENSIONS[cardExtension(file)]) {
      message = 'Upload a PDF, JPG, PNG, or WEBP file.';
    } else if (file.size > CARD_MAX_BYTES) {
      message = 'Business card must be 10 MB or smaller.';
    }
    if (!message) return true;
    input.setCustomValidity(message);
    input.reportValidity();
    input.setCustomValidity('');
    return false;
  }

  function bindBusinessCard(form) {
    var input = form.querySelector('[data-trade-apply-card]');
    var nameEl = form.querySelector('[data-trade-apply-card-name]');
    var field = form.querySelector('[data-trade-apply-card-field]');
    if (!input || input.dataset.tradeApplyCardBound === 'true') return;
    input.dataset.tradeApplyCardBound = 'true';
    input.addEventListener('change', function () {
      var file = getBusinessCardFile(form);
      if (nameEl) nameEl.textContent = file ? file.name : 'PDF, JPG, or PNG';
      if (field) field.classList.toggle('is-selected', !!file);
    });
  }

  function isValidEmail(value) {
    return /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(
      String(value || '').trim()
    );
  }

  function submitApplication(root, form, submitBtn) {
    if (root.dataset.tradeApplySubmitting === 'true') {
      console.warn('[Trade apply] Ignoring submit — already submitting');
      return;
    }

    var emailInput = form.querySelector('[name="email"]');
    if (emailInput && !isValidEmail(emailInput.value)) {
      emailInput.setCustomValidity('Enter a valid email like you@email.com');
      emailInput.reportValidity();
      emailInput.setCustomValidity('');
      return;
    }

    if (!validateBusinessCard(form)) return;

    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      console.warn('[Trade apply] Form invalid — browser validation blocked submit');
      form.reportValidity();
      return;
    }

    root.dataset.tradeApplySubmitting = 'true';
    if (submitBtn) submitBtn.disabled = true;

    postHubSpot(root, form)
      .then(function (body) {
        console.log('[Trade apply] Submit OK — redirecting to thank-you page', body);
        redirectToThankYou(root);
      })
      .catch(function (err) {
        console.error('[Trade apply] Submit error', err);
        showError(root, (err && err.message) || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        root.dataset.tradeApplySubmitting = 'false';
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function bindRoot(root) {
    if (!root || root.dataset.tradeApplyBound === 'true') return;
    root.dataset.tradeApplyBound = 'true';

    var form = root.querySelector('[data-trade-apply-form]') || root.querySelector('form');
    var submitBtn = root.querySelector('[data-trade-apply-submit]');
    if (!form) return;
    bindBusinessCard(form);

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        submitApplication(root, form, submitBtn);
        return false;
      },
      true
    );
  }

  function bindAll() {
    document.querySelectorAll('[data-trade-apply]').forEach(bindRoot);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var root = form.closest('[data-trade-apply]');
      if (!root) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      bindRoot(root);
      submitApplication(root, form, root.querySelector('[data-trade-apply-submit]'));
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-trade-apply]').forEach(function (root) {
      root.dataset.tradeApplyBound = 'false';
    });
    bindAll();
  });
})();
